import { ControllingFiltersForm } from '../../filters'
import { formatDateDDMMYYYY } from '../../../../shared/helpers/date'
import { SCHEDULE_LABELS, DEVIATION_LABELS, REASON_FILTER_LABELS } from './controllingExport.constants'

export interface ActiveFilterItem {
  key: string
  label: string
  value: string
}

export function buildActiveFilterItems(
  filters: ControllingFiltersForm,
  technicianLabel?: string | null,
  tradeLabel?: string | null,
  technicianTradeLabel?: string | null,
): ActiveFilterItem[] {
  const result: ActiveFilterItem[] = []

  if (filters.dateFrom || filters.dateTo) {
    const from = filters.dateFrom ? formatDateDDMMYYYY(filters.dateFrom) : '...'
    const to = filters.dateTo ? formatDateDDMMYYYY(filters.dateTo) : '...'
    result.push({ key: 'zeitraum', label: 'Zeitraum', value: `${from} – ${to}` })
  }
  if (filters.workOrderId) {
    result.push({ key: 'workOrderId', label: 'Auftrags-ID', value: filters.workOrderId })
  }
  if (filters.technicianId && technicianLabel) {
    result.push({ key: 'technician', label: 'Handwerker', value: technicianLabel })
  }
  if (filters.tenant) {
    result.push({ key: 'tenant', label: 'Mieter', value: filters.tenant })
  }
  if (filters.ve) {
    result.push({ key: 've', label: 'VE', value: filters.ve })
  }
  if (filters.building) {
    result.push({ key: 'building', label: 'Gebäude', value: filters.building })
  }
  if (filters.scheduleStatus.length > 0) {
    result.push({
      key: 'scheduleStatus',
      label: 'Terminstatus',
      value: filters.scheduleStatus.map((s) => SCHEDULE_LABELS[s]).join(', '),
    })
  }
  if (filters.deviationStatus.length > 0) {
    result.push({
      key: 'deviationStatus',
      label: 'Soll-Ist-Status',
      value: filters.deviationStatus.map((s) => DEVIATION_LABELS[s]).join(', '),
    })
  }
  if (filters.reasons.length > 0) {
    result.push({
      key: 'reasons',
      label: 'Grund',
      value: filters.reasons.map((r) => REASON_FILTER_LABELS[r]).join(', '),
    })
  }
  if (filters.tradeId && tradeLabel) {
    result.push({ key: 'trade', label: 'Auftrag Gewerk', value: tradeLabel })
  }
  if (filters.technicianTradeId && technicianTradeLabel) {
    result.push({ key: 'technicianTrade', label: 'Handwerker Gewerk', value: technicianTradeLabel })
  }
  if (filters.actualTravelHoursMin || filters.actualTravelHoursMax) {
    const min = filters.actualTravelHoursMin || '0'
    const max = filters.actualTravelHoursMax || '∞'
    result.push({ key: 'travelHours', label: 'Fahrt Ist (Std)', value: `${min} – ${max}` })
  }
  if (filters.actualWorkHoursMin || filters.actualWorkHoursMax) {
    const min = filters.actualWorkHoursMin || '0'
    const max = filters.actualWorkHoursMax || '∞'
    result.push({ key: 'workHoursFilter', label: 'Arbeit Ist (Std)', value: `${min} – ${max}` })
  }
  if (filters.actualTotalHoursMin || filters.actualTotalHoursMax) {
    const min = filters.actualTotalHoursMin || '0'
    const max = filters.actualTotalHoursMax || '∞'
    result.push({ key: 'totalHoursFilter', label: 'Gesamt Ist (Std)', value: `${min} – ${max}` })
  }
  if (filters.deviationMin || filters.deviationMax) {
    const min = filters.deviationMin || '0'
    const max = filters.deviationMax || '∞'
    result.push({ key: 'deviationFilter', label: 'Abweichung %', value: `${min} – ${max}` })
  }

  return result
}
